module.exports = __webpack_public_path__ + "img/result-detail-output-inright03.91727c8e.svg";